'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  width: 100%;\n'], ['\n  text-align: center;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\n'], ['\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var OptionToolTipComponent = _styledComponents2.default.div(_templateObject);

var OtherOption = _styledComponents2.default.div(_templateObject2);

var WorkflowToolTipOptions = function (_React$Component) {
    _inherits(WorkflowToolTipOptions, _React$Component);

    function WorkflowToolTipOptions(props) {
        _classCallCheck(this, WorkflowToolTipOptions);

        var _this = _possibleConstructorReturn(this, (WorkflowToolTipOptions.__proto__ || Object.getPrototypeOf(WorkflowToolTipOptions)).call(this, props));

        _this.state = {
            option: null
        };
        return _this;
    }

    _createClass(WorkflowToolTipOptions, [{
        key: 'handleOption',
        value: function handleOption(value) {
            this.setState({
                option: value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var header = (0, _metrixCommon.getElementValueByType)((0, _metrixCommon.getElementsByType)(this.props.component.elements, 'header'), 'text');

            var label = (0, _metrixCommon.getElementValueByType)((0, _metrixCommon.getElementsByType)(this.props.component.elements, 'label'), 'text');

            var options = (0, _metrixCommon.getElementsByType)(this.props.component.elements, 'options');

            var promotedOptions = [],
                otherOptions = [];

            options.forEach(function (element) {
                var promoted = element.elements.find(function (x) {
                    return x.code === 'promoted';
                });

                if (promoted.value === 'true') {
                    promotedOptions.push(element);
                } else {

                    element.value = element.elements.find(function (x) {
                        return x.type === 'header';
                    }).value;

                    otherOptions.push(element);
                }
            });

            var selectedOtherOption = otherOptions.length > 0 && this.state.option && options.find(function (x) {
                return x.code === _this2.state.option.code;
            });

            return _react2.default.createElement(
                OptionToolTipComponent,
                { key: this.props.componentCode + 'Component' },
                _react2.default.createElement(_metrixCommon.Header, {
                    key: this.props.componentCode + 'Header',
                    text: header,
                    size: _metrixCommon.Sizes.lg,
                    top: _metrixCommon.Sizes.lg
                }),
                _react2.default.createElement(_metrixCommon.Label, {
                    key: this.props.componentCode + 'Text',
                    text: label,
                    top: _metrixCommon.Sizes.md,
                    bottom: _metrixCommon.Sizes.xl
                }),
                otherOptions.length > 0 && _react2.default.createElement(_metrixCommon.Label, {
                    key: this.props.componentCode + 'MostCommon',
                    bold: true,
                    bottom: _metrixCommon.Sizes.lg,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.components.OptionsToolTip.mostCommon' })
                }),
                _react2.default.createElement(
                    _metrixCommon.Grid,
                    {
                        key: this.props.componentCode + 'Container' },
                    _react2.default.createElement(
                        _metrixCommon.Row,
                        { center: true },
                        promotedOptions.length > 0 && promotedOptions.map(function (promotedOption, index) {

                            var promotedOptionLabel = promotedOption.elements.find(function (x) {
                                return x.type === "label";
                            });

                            return _react2.default.createElement(
                                _metrixCommon.Column,
                                { xs: 12, lg: 6,
                                    key: _this2.props.componentCode + 'HeaderColumn' + index },
                                _react2.default.createElement(_metrixCommon.ToolTipIcon, { icon: promotedOption.code, toolTipType: _this2.props.component.value }),
                                _react2.default.createElement(_metrixCommon.Label, {
                                    text: promotedOption.elements.find(function (x) {
                                        return x.type === "header";
                                    }).value,
                                    bold: true,
                                    top: _metrixCommon.Sizes.sm,
                                    bottom: _metrixCommon.Sizes.xs }),
                                promotedOptionLabel && _react2.default.createElement(_metrixCommon.Label, {
                                    text: promotedOptionLabel.value,
                                    top: _metrixCommon.Sizes.xxs,
                                    bottom: _metrixCommon.Sizes.lg })
                            );
                        })
                    )
                ),
                otherOptions.length > 0 && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_metrixCommon.Separator, { orientation: 'horizontal', top: _metrixCommon.Sizes.xl, bottom: _metrixCommon.Sizes.xl }),
                    _react2.default.createElement(_metrixCommon.Label, {
                        key: this.props.componentCode + 'BotomTitle',
                        bold: true,
                        bottom: _metrixCommon.Sizes.lg,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.components.OptionsToolTip.others' })
                    }),
                    _react2.default.createElement(_metrixCommon.Label, {
                        key: this.props.componentCode + 'DropDownLabel',
                        textAlign: _metrixCommon.Alignments.left,
                        bottom: _metrixCommon.Sizes.xs,
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'app.components.OptionsToolTip.exploreOtherOptions' })
                    }),
                    _react2.default.createElement(_metrixCommon.DropDown, { references: otherOptions,
                        changeEvent: function changeEvent(value) {
                            return _this2.handleOption(value);
                        },
                        placeholder: '',
                        value: this.state.option,
                        bottom: _metrixCommon.Sizes.lg }),
                    _react2.default.createElement(
                        OtherOption,
                        { key: this.props.componentCode + 'OtherOption' },
                        _react2.default.createElement(_metrixCommon.ToolTipIcon, {
                            toolTipType: this.props.component.value,
                            icon: selectedOtherOption && selectedOtherOption.code }),
                        _react2.default.createElement(_metrixCommon.Label, { text: selectedOtherOption && selectedOtherOption.elements.find(function (x) {
                                return x.type === "header";
                            }).value,
                            bold: true,
                            top: _metrixCommon.Sizes.sm,
                            bottom: _metrixCommon.Sizes.xs }),
                        _react2.default.createElement(_metrixCommon.Label, { text: selectedOtherOption && selectedOtherOption.elements.find(function (x) {
                                return x.type === "label";
                            }).value })
                    )
                )
            );
        }
    }]);

    return WorkflowToolTipOptions;
}(_react2.default.Component);

exports.default = WorkflowToolTipOptions;